import React, { Fragment, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { withFormik, FieldArray } from 'formik';
import { MdHelpOutline } from '../../../Common/Icons';
import DeleteIcon from '../../../Assets/General/DeleteIcon';
import AddContact from '../../../Pages/Contact/AddContact';
import {
  Form,
  Field,
  TaxForm,
  AddItem,
  FormAction,
  ErrorFocus,
  FormSection,
} from '../';
import OldAccount from '../../../Pages/Account/AccountForm';
import AccountForm from '../../../Pages/ChartOfAccounts/AccountForm';
import { formSubmit, getError, validate } from '../FormHelper';
import ItemAccountsIcon from '../../../Assets/General/ItemAccountsIcon';
import ItemAttributeOptionForm from './ItemAttributeOptionForm/ItemAttributeOption';
import { CustomModal, SmallLoader, ImagePreview, ImageCropper } from '../../';
import {
  checkError,
  setObjInLS,
  restRequest,
  getObjFromLS,
  confirmationAlert,
  hasPermissionCustom,
} from '../../../Helpers';
import {
  required,
  ValidateMax50,
  ValidateMax15,
  ValidateMax200,
  ValidateMax240,
  ValidateMax255,
  wrapValidateMax,
  ValidateRequired,
  ValidateMax10Billion,
  ValidateMax1000,
  ValidateMax20, ValidateNumerMoreThenZero,
} from '../../../Helpers/Validator';
import { validateCreateItemForm } from '../../../Helpers/FormValidator';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import { showRawItems } from "../../../Helpers/AuthHelper";
//const { Grid, GridLayout } = Layout;

// const skipButton = localStorage.getItem('skipBtnoldAccount');
const getYupValidationSchema = (_, props) => {
  return Yup.object().shape({
    name: required(ValidateMax240),
    description: ValidateMax1000,
    salesDescription: wrapValidateMax(Yup.string().nullable(), 255),
    purchaseDescription: wrapValidateMax(Yup.string().nullable(), 255),
    sku: required(ValidateMax50),
    unit: required(ValidateMax15),
    upc: wrapValidateMax(Yup.string().nullable(), 13),
    mpn: wrapValidateMax(Yup.string().nullable(), 17),
    ean: wrapValidateMax(Yup.string().nullable(), 14),
    isbn: wrapValidateMax(Yup.string().nullable(), 17),
    dimensions: wrapValidateMax(Yup.string().nullable(), 17),
    weight: wrapValidateMax(Yup.string().nullable(), 17),
    manufacturer: ValidateMax200,
    brand: wrapValidateMax(Yup.string().nullable().trim(), 200),
    //salesUnitPrice: required(ValidateMax10Billion),
    salesUnitPrice: ValidateMax10Billion,
    salesAccountID: ValidateRequired,
    //purchaseUnitPrice: required(ValidateMax10Billion),
    purchaseUnitPrice: ValidateMax10Billion,
    purchaseAccountID: ValidateRequired,
    quantityPerPack: props.isTaxInMilliGram
      ? Yup.number()
        .typeError('Required')
        .min(1, 'Must be at least 1')
        .transform((value, originalValue) =>
          originalValue === '' || isNaN(originalValue) ? undefined : value
        )
        .required('Required')
      : Yup.number().notRequired().nullable(),

    miliGramPerUnit: props.isTaxInMilliGram
      ? ValidateNumerMoreThenZero
        .transform((value, originalValue) =>
          originalValue === '' || isNaN(originalValue) ? undefined : value
        )
        .required('Required')
      : Yup.number().notRequired().nullable(),

    // openingStockValue: props.trackInventory //TODO: commented becuase of validations bypass by these checks.
    //   ? ValidateMax10Billion.when('warehouses', {
    //       is: (warehouse) =>
    //         warehouse.some((w) => w.openingStock > 0),
    //       then: Yup.mixed().required('Required'),
    //       otherwise: Yup.mixed().notRequired(),
    //     })
    //   : Yup.mixed().notRequired(),
    reorderLevel: ValidateMax10Billion,
    warehouses: props.trackInventory
      ? Yup.array()
        .of(
          Yup.object().shape({
            name: ValidateRequired,
            openingStock: ValidateMax10Billion,
          })
        )
        .min(1, t('Items.warehouse_required'))
      : Yup.mixed().notRequired(),

    attributes:
      props.formType === 'itemGroup'
        ? Yup.array().of(
          Yup.object().shape({
            attributeOptionValue: ValidateRequired,
          })
        )
        : Yup.mixed().notRequired(),
  });
};
let globalIndex = null;
const formEnhancer = withFormik({
  validate: validate(getYupValidationSchema),
  mapPropsToValues: ({ item }) => ({
    ...item,
    rawItems: item?.rawItems || [{ raw_item_id: null, quantity: 0 }], // Initialize rawItems

    loadingAccounts: {
      salesAccounts: false,
      purchaseAccounts: false,
      inventoryAccounts: false,
    },
    showAccountModal: false,
    showTaxModal: false,
    showOptionsModal: false,
    showImageCropModal: false,
    showContactCreateModal: false,
  }),
  mapPropsToStatus: (props) => {
    // console.log(props, 'props in form enhancer');
    return ({
      accountType: '',
      rawItemsList: props.rawItemsList,

      taxList: props.taxList,
      currency: props.currency,
      vendorsList: props.vendorsList,
      allWarehouses: props.allWarehouses,
      salesAccounts: props.salesAccounts,
      emptyWarehouse: props.emptyWarehouse,
      warehousesList: props.warehousesList,
      purchaseAccounts: props.purchaseAccounts,
      inventoryAccounts: props.inventoryAccounts,
    });
  },
  handleSubmit: (values, bag) => {
    handleFormSubmit(values, bag);
  },
});
const TrackTaxMesaurementTitle = ({
  isTaxInMilliGram,
  handleTaxinMeasurement,
}) => (
  <div style={{ marginTop: '-30px' }}>
    {' '}
    <div className="form-checkbox items-checkbox">
      <label className="form-checkbox-label track_inv_checkbox">
        <input
          id="isTaxInMilliGram"
          checked={isTaxInMilliGram}
          type="checkbox"
          onChange={() => handleTaxinMeasurement()}
        />
        <span className="check-uncheck">
          {isTaxInMilliGram ? (
            <i className="far fa-check-square"></i>
          ) : (
            <i className="far fa-square"></i>
          )}
          {/* <Checked /> */}
        </span>
      </label>
      <label className="bold" htmlFor="isTaxInMilliGram">
        {'Calculate Tax per Milli Liter/ Gram'}
      </label>
      <span className="icon_div">
        <MdHelpOutline
          className="material-icon blue-icon help"
          style={{ marginRight: '1.7rem' }}
        />
        <div className="tooltip_tooltip">
          {
            "Enter tax amount for each 1 ml or gram. Total tax will be calculated based on the item's total quantity"
          }
        </div>
      </span>
    </div>
    {/* <div className="trackDiv">
      <span className="trackSpan"> {t('Items.track_inventory_info')}</span>
    </div> */}
  </div>
);
const TrackInventoryTitle = ({ trackInventory, handleTrackInventory }) => (
  <div>
    {' '}
    <div className="form-checkbox items-checkbox">
      <label className="form-checkbox-label track_inv_checkbox">
        <input
          id="trackInventory"
          checked={trackInventory}
          type="checkbox"
          onChange={() => handleTrackInventory()}
        />
        <span className="check-uncheck">
          {trackInventory ? (
            <i className="far fa-check-square"></i>
          ) : (
            <i className="far fa-square"></i>
          )}
          {/* <Checked /> */}
        </span>
      </label>
      <label className="bold" htmlFor="trackInventory">
        {t('Items.track_inventory')}
      </label>
      <span className="icon_div">
        <MdHelpOutline
          className="material-icon blue-icon help"
          style={{ marginRight: '1.7rem' }}
        />
        <div className="tooltip_tooltip">
          {t('Items.track_inventory_tooltip')}
        </div>
      </span>
    </div>
    <div className="trackDiv">
      <span className="trackSpan"> {t('Items.track_inventory_info')}</span>
    </div>
  </div>
);

const variantName = (id, options) => {
  let name = null;
  options.forEach((opt) => {
    if (id === opt.id) {
      name = opt.name;
    }
  });
  return name;
};
const handleFormSubmit = (
  values,
  {
    setSubmitting,
    props: {
      type,
      inModal,
      history,
      formType,
      location,
      setPrompt,
      requestUrl,
      handleToast,
      onSubmitModal,
      trackInventory,
      isTaxInMilliGram,
      successMessage,
      closeModal: closeItem,
    },
  }
) => {
  console.log(values, 'values on submit');
  const { pathname = '', search = 'new-item' } = location;
  let variant = null;
  if (formType === 'itemGroup') {
    let newOpt = '';
    values.attributes.forEach(function (attr, index) {
      if (index === 0) {
        newOpt = attr.attributeOptionName.toLowerCase();
      } else {
        newOpt = newOpt + '/' + attr.attributeOptionName.toLowerCase();
      }
    });
    if (values.possibleCombinations.includes(newOpt)) {
      handleToast(t('Items.duplicate_variant_attributes'), 'error');
      setSubmitting(false);
      return false;
    }
    variant = values.attributes.map((val, i) => ({
      [val.name]: variantName(
        val.attributeOptionValue,
        val.item_attribute_option
      ),
    }));
  }
  if (
    trackInventory &&
    values.openingStockValue > 0 &&
    !values.transactionInfo &&
    !values.warehouses.filter((val) => val.openingStock > 0).length
  ) {
    handleToast(t('Items.warehouse_stock_required'), 'error');
    setSubmitting(false);
    return false;
  } else if (
    trackInventory &&
    (values.openingStockValue <= 0 || !values.openingStockValue) &&
    values.warehouses.filter(
      (val) => val.openingStock > 0 && !val.transactionInfo
    ).length
  ) {
    handleToast(t('Items.opening_stock_value_required'), 'error');
    setSubmitting(false);
    return false;
  }
  let data = new FormData();
  if (formType === 'itemGroup') {
    for (let [index, attr] of values.attributes.entries()) {
      data.append(`attributes[${index}]`, JSON.stringify(attr));
    }
    data.append('item_group_name', values.itemGroupName);
    data.append('item_group_id', values.itemGroupId);
    data.append('variant', JSON.stringify(variant));
  }

  console.log(values);
  data.append('type', values.type);
  data.append('name', values.name);
  data.append('sku', values.sku);
  data.append('unit', values.unit);
  data.append('upc', values.upc);
  data.append('ean', values.ean);
  data.append('mpn', values.mpn);
  data.append('isbn', values.isbn);
  data.append('manufacturer', values.manufacturer);
  data.append('brand', values.brand);
  data.append('dimensions', values.dimensions || '');
  data.append('weight', values.weight || '');
  data.append('clone_status', clone_status);
  data.append('description', values.description);
  data.append('tax_per_measurement', Boolean(isTaxInMilliGram));
  data.append('pack_quantity', values.quantityPerPack || 0);
  data.append('volume_per_piece', values.miliGramPerUnit || 0);
  // data.append('base84Image', values.base84Image)
  //values.salesUnitPrice && data.append('sales_unit_price', values.salesUnitPrice || 0)
  data.append('sales_unit_price', values.salesUnitPrice || 0);
  values.salesAccountID &&
    data.append('sales_account_id', values.salesAccountID);
  values.inventoryAccountID &&
    data.append('inventory_account_id', values.inventoryAccountID);
  data.append('sales_description', values.salesDescription);
  values.taxID && data.append('tax_id', values.taxID);
  //values.purchaseUnitPrice && data.append('purchase_unit_price', values.purchaseUnitPrice || 0)
  data.append('purchase_unit_price', values.purchaseUnitPrice || 0);
  values.purchaseAccountID &&
    data.append('purchase_account_id', values.purchaseAccountID);
  data.append('purchase_description', values.purchaseDescription);
  values.vendorID && data.append('vendor_id', values.vendorID);
  data.append('opening_stock_value', values.openingStockValue || 0);
  data.append('reorder_level', values.reorderLevel || 0);
  data.append(
    'save-as-new',
    pathname.includes('/items/edit') && search === '?new-item'
  );
  for (let [index, warehouse] of values.warehouses.entries()) {
    if (warehouse.is_active === 1) {
      data.append(`warehouses[${index}][id]`, warehouse.id);
      data.append(
        `warehouses[${index}][opening_stock]`,
        warehouse.openingStock || 0
      );
    }
  }
  // for (let [index, attr] of values.
  //   rawItems.entries()) {
  //   data.append(`raw_items[${index}]`, JSON.stringify(attr));
  // }
  for (let [index, attr] of values.rawItems.entries()) {
    // if (warehouse.is_active === 1) {
    data.append(`raw_items[${index}][raw_item_id]`, JSON.stringify(attr.raw_item_id));
    data.append(
      `raw_items[${index}][quantity]`,
      JSON.stringify(attr.quantity) || 0
    );
    // }
  }
  for (let [index, imageUrl] of values.images.entries()) {
    data.append(`images[${index}]`, imageUrl);
  }

  data.append('upload_images', []);
  data.append('inventory_type', trackInventory ? 'inventory' : 'noninventory');
  for (let [index, file] of values.base84Image.entries()) {
    data.append(`base84Image[${index}]`, file);
  }
  restRequest('post', requestUrl, data)
    .then((res) => {
      setPrompt(false);
      if (inModal) {
        onSubmitModal(res);
        closeItem();
      } else {
        successMessage();
        let dataFromLS = getObjFromLS('module');
        if (!dataFromLS) {
          let obj = {
            prevId: null,
            id: requestUrl.split('/')[1] || '',
            nextId: null,
            moduleName: 'items',
            urlPath: '/items',
            queryParam: window.location.search,
          };
          setObjInLS('module', obj);
          dataFromLS = getObjFromLS('module');
        }
        if (type === 'add') {
          if (formType === 'itemGroup') {
            setObjInLS('module', {
              ...dataFromLS,
              moduleName: 'item_groups',
              queryParam: dataFromLS.dataFromLS ? dataFromLS.dataFromLS : '',
              urlPath: '/item-groups',
            });
          } else {
            setObjInLS('module', {
              ...dataFromLS,
              moduleName: 'items',
              queryParam: dataFromLS.dataFromLS ? dataFromLS.dataFromLS : '',
              id: type === 'add' ? res.data.id : dataFromLS.id,
              urlPath: '/items',
            });
          }
        } else if (type === 'clone') {
          setObjInLS('module', {
            ...dataFromLS,
            moduleName: 'items',
            queryParam: dataFromLS.dataFromLS ? dataFromLS.dataFromLS : '',
            id: type === 'clone' ? res.data.id : dataFromLS.id,
            urlPath: '/items',
          });
        }
        type === 'edit' &&
          setObjInLS('module', {
            ...dataFromLS,
            action: type === 'add' ? 'add' : 'justedit',
            queryParam: dataFromLS.queryParam ? dataFromLS.queryParam : '',
            urlPath: '/items',
          });
        return history.push('/r');
      }
    })
    .catch((error) => {
      checkError(error);
      handleToast(error, 'error');
      setSubmitting(false);
    });
};

var clone_status = 0;

const setCloneStatus = (type) => {
  if (type === 'clone') {
    clone_status = 1;
  } else {
    clone_status = 0;
  }
};

const ItemForm = ({
  type,
  item,
  values,
  status,
  errors,
  touched,
  inModal,
  history,
  formType,
  setValues,
  setStatus,
  handleBlur,
  submitCount,
  suggestions,
  handleToast,
  isSubmitting,
  handleSubmit,
  handleChange,
  allWarehouses,
  setFieldValue,
  trackInventory,
  isTaxInMilliGram,
  enableTaxPerUnitMeasurement,
  warehousesList,
  setFieldTouched,
  modalSource = true,
  handleTrackInventory,
  handleisTaxinGram,
  closeModal: closeItem,
  onSuggestionsFetchRequested,
  onSuggestionsClearRequested,
  ...props
}) => {
  // console.log('skipButton', skipButton);
  const { t } = useTranslation();
  var base64Images = [];
  const [staticVal, setStaticValues] = useState({});
  const [showPrompt, setShowPrompt] = useState(false);
  const [skipButton, setskipButton] = useState(
    localStorage.getItem('skipBtnoldAccount')
  );
  useEffect(() => {
    setskipButton(JSON.parse(localStorage.getItem('skipBtnoldAccount')));
  }, [skipButton]);
  useEffect(() => {
    handleAlert();
    // eslint-disable-next-line
  }, [values, trackInventory, staticVal]);
  useEffect(() => {
    setStaticValues({
      ...values,
      trackInventory,
      type,
    });
    // eslint-disable-next-line
  }, []);
  const handleAlert = () => {
    let { checkout } = validateCreateItemForm(
      {
        ...values,
        trackInventory,
        type,
      },
      staticVal
    );
    if (!checkout && !inModal) props.setPrompt();
    else if (!checkout && inModal) props.handlePrompt();
    else {
      if (inModal) props.handlePrompt(false);
      props.setPrompt(false);
    }
  };

  const generateSku = () => {
    setFieldValue('skuLoading', true);
    restRequest('get', 'items/generatesku')
      .then((res) => {
        setFieldValue('skuLoading', false);
        setFieldValue('sku', res.sku);
      })
      .catch((error) => {
        setFieldValue('skuLoading', false);
        handleToast(error, 'error');
      });
  };
  setCloneStatus(type);
  const handleFiles = (accepted, rejected) => {
    const allowedExtensions = ['image/png', 'image/jpg', 'image/jpeg'];
    const allTypes = accepted.map((data) => data?.type);
    const hasJfif = accepted.some((file) =>
      file.name.toLowerCase().endsWith('.jfif')
    );
    const hasInvalidType = allTypes?.some(
      (type) => !allowedExtensions.includes(type)
    );

    if (hasInvalidType || hasJfif) {
      handleToast(t('Contacts.invalid_size'), 'error');

      return null;
    }

    if (rejected.length) {
      if (rejected.length === 1) {
        handleToast(t('Items.invalid_files'), 'error');
      } else {
        handleToast(`${rejected.length} ${t('Items.invalid_files')}`, 'error');
      }
    }

    if (accepted.length) {
      let previousFiles = [...values.uploadImages];
      if ([...previousFiles, ...accepted].length > 5) {
        handleToast(t('Item.max_images'), 'error');
        return null;
      }
      let updatedFiles = accepted.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );
      if (
        values.images.length +
        values.uploadImages.length +
        updatedFiles.length >
        5
      ) {
        handleToast(t('Item.max_images'), 'error');
        return null;
      }
      setFieldValue('imageUpload', [...previousFiles, ...updatedFiles]);
      setFieldValue('showImageCropModal', true);
    }
  };

  const handleImageDelete = (image) => {
    if (typeof image === 'string') {
      // previous uploaded image (url)
      setFieldValue(
        'images',
        values.images.filter((el) => el !== image)
      );
    } else {
      setFieldValue(
        'uploadImages',
        values.uploadImages.filter((el) => el !== image)
      );
      setFieldValue(
        'base84Image',
        values.base84Image.filter((el) => el !== image.preview)
      );
    }
  };

  const handleTaxChange = (option) => {
    if (option !== null) {
      // Add New
      if (option.value === 'createNew') {
        setFieldValue('showTaxModal', true);
      } else {
        // tax selected
        const taxID = option.value;
        setFieldValue('taxID', taxID);
      }
    } else {
      // deselect tax
      setFieldValue('taxID', null);
    }
  };

  const handleAttrChange = (option, index) => {
    if (option !== null) {
      // Add New
      if (option.value === 'createNew') {
        setFieldValue('showOptionsModal', true);
        globalIndex = index;
      } else {
        const optID = option.id;
        values.attributes[index].attributeOptionValue = optID;
        values.attributes[index].attributeOptionName = option.name;
        setFieldValue(
          `values.attributes[${index}].attributeOptionValue`,
          optID
        );
        setFieldValue(
          `values.attributes[${index}].attributeOptionName`,
          option.name
        );
      }
    } else {
      values.attributes[index].attributeOptionValue = null;
      values.attributes[index].attributeOptionName = null;
      setFieldValue(`values.attributes[${index}].attributeOptionValue`, null);
      setFieldValue(`values.attributes[${index}].attributeOptionName`, null);
    }
  };

  const handleVendorChange = (option) => {
    if (option !== null) {
      if (option.value === 'createNew') {
        setFieldValue('showContactCreateModal', true);
      } else {
        const vendorID = option.value;
        setFieldValue('vendorID', vendorID);
      }
    } else {
      setFieldValue('vendorID', null);
    }
  };
  const handlerawItemChange = (option) => {
    if (option !== null) {
      const raw_item_id = option.value;
      setFieldValue('raw_item_id', raw_item_id);
    } else {
      setFieldValue('raw_item_id', null);
    }
  }
  const handleSelectedWarehouses = (option, index) => {
    let newWarehouse = {
      id: option.id,
      name: option.name,
      address: option.address,
      city: option.city,
      state: option.state,
      country: option.country,
      zipCode: option.zip_code,
      openingStock: values.warehouses[index].openingStock,
      is_active: 1,
    };

    let updatedWarehousesList = [
      ...Object.assign([...values.warehouses], { [index]: newWarehouse }),
    ];
    setFieldValue('warehouses', updatedWarehousesList);

    setStatus({
      ...status,
      warehousesList: status.warehousesList.filter(
        (warehouse) => warehouse.id !== option.id
      ),
    });
  };

  const handleRemoveItem = (removeIndex) => {
    if (values.warehouses.length === 1) {
      values.warehouses.push(status.emptyWarehouse);
    }
    let updatedWarehousesList = values.warehouses.filter(
      (_, index) => index !== removeIndex
    );
    setFieldValue('warehouses', updatedWarehousesList);
    // setFieldValue('warehouse_removed', true);
  };

  const handleAccountModal = (accountType) => {
    // sales, purchase
    setStatus({
      ...status,
      accountType:
        accountType === 'sales'
          ? 'sales'
          : accountType === 'inventory'
            ? 'inventory'
            : 'expense',
    });
    setFieldValue('showAccountModal', true);
  };

  function closeModal() {
    setValues({
      ...values,
      showAccountModal: false,
      showTaxModal: false,
      showOptionsModal: false,
      showImageCropModal: false,
      showContactCreateModal: false,
    });
  }

  const AddAccount = (accountType, newAccount) => {
    const fieldName =
      accountType === 'sales'
        ? 'salesAccountID'
        : accountType === 'expense'
          ? 'purchaseAccountID'
          : 'inventoryAccountID';

    const accountList =
      accountType === 'sales'
        ? status.salesAccounts
        : accountType === 'expense'
          ? status.purchaseAccounts
          : status.inventoryAccounts;

    const updatedAccountList = [...accountList, newAccount.data];

    if (accountType === 'sales') {
      setStatus({ ...status, salesAccounts: updatedAccountList });
    } else if (accountType === 'expense') {
      setStatus({ ...status, purchaseAccounts: updatedAccountList });
    } else {
      setStatus({ ...status, inventoryAccounts: updatedAccountList });
    }

    setFieldValue(fieldName, newAccount.data.id);
  };
  const updateAccount = (accountType, newAccount) => {
    const fieldName =
      accountType === 'sales' ? 'salesAccountID' : 'purchaseAccountID';
    const accountList =
      accountType === 'sales' ? status.salesAccounts : status.purchaseAccounts;

    const updatedAccountList = [...accountList, newAccount];
    if (accountType === 'sales') {
      setStatus({ ...status, salesAccounts: updatedAccountList });
    } else {
      setStatus({ ...status, purchaseAccounts: updatedAccountList });
    }
    closeModal();
    setFieldValue(fieldName, newAccount.id);
  };
  const accountDropDownField = (accountType) => {
    const accountList =
      accountType === 'sales'
        ? status.salesAccounts
        : accountType === 'expense'
          ? status.purchaseAccounts
          : status.inventoryAccounts;
    return (
      <div className="flex-100 position-relative">
        <Field
          className="overForm"
          type="dropdown"
          dropdownValue="id"
          size="large"
          dropdownLabel="title"
          name={`${t(`Items.${accountType}`)} ${t(`Items.account`)}`}
          value={
            accountType === 'sales'
              ? values.salesAccountID
              : accountType === 'expense'
                ? values.purchaseAccountID
                : values.inventoryAccountID
          }
          id={
            accountType === 'sales'
              ? 'salesAccountID'
              : accountType === 'expense'
                ? 'purchaseAccountID'
                : 'inventoryAccountID'
          }
          options={accountList}
          handleChange={(option) => {
            setFieldValue(
              accountType === 'sales'
                ? 'salesAccountID'
                : accountType === 'expense'
                  ? 'purchaseAccountID'
                  : 'inventoryAccountID',
              option.id
            );
          }}
          clearable={false}
        />
        {/* {!inModal && hasPermissionCustom('account', 'Create') && (
          <button
            className="button form-field--side-btn account_addnew"
            type="button"
            onClick={() => handleAccountModal(accountType)}
            disabled={!hasPermissionCustom('account', 'Create')}
          >
            {t('Items.add_new')}
          </button>
        )} */}
      </div>
    );
  };
  const handlePrompt = (status = true) => setShowPrompt(status);
  String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  };
  const newAccountModal = () => {
    let { accountType } = status;
    return (
      <CustomModal
        fill="#000000"
        onClose={closeModal}
        className="widthClass"
        renderActions={false}
        Icon={ItemAccountsIcon}
        showPrompt={showPrompt}
        showModal={values.showAccountModal}
        title={`${t('Items.new')} ${accountType === 'expense'
          ? t(`Items.expense`).capitalize()
          : accountType === 'inventory'
            ? t(`Items.inventory`).capitalize()
            : accountType === 'income'
              ? t(`Items.income:`).capitalize()
              : `${accountType.capitalize()}`
          } ${t('PurchaseOrder.account')}`}
      >
        <AccountForm
          itemModal
          accountType={
            accountType === 'sales'
              ? 'income'
              : accountType === 'inventory'
                ? 'inventory'
                : 'expense'
          }
          inModal
          history={history}
          onClose={closeModal}
          handleToast={handleToast}
          handlePrompt={handlePrompt}
          onSubmitForm={(account) => AddAccount(accountType, account)}
        />
      </CustomModal>
    );
  };
  const oldAccountModal = () => {
    let { accountType } = status;
    return (
      <CustomModal
        fill="#000000"
        className="widthClass"
        onClose={closeModal}
        renderActions={false}
        Icon={ItemAccountsIcon}
        showPrompt={showPrompt}
        showModal={values.showAccountModal}
        title={`New ${accountType.capitalize()} Account`}
      >
        <OldAccount
          inModal
          history={history}
          onClose={closeModal}
          handleToast={handleToast}
          handlePrompt={handlePrompt}
          onSubmit={(account) => updateAccount(accountType, account)}
          accountType={accountType === 'sales' ? 'sales' : 'purchase'}
        />
      </CustomModal>
    );
  };
  const contactCreateModal = () => {
    return (
      <CustomModal
        size="large"
        title="Add Contact"
        onClose={closeModal}
        renderActions={false}
        showPrompt={showPrompt}
        customWidth="contact-modal-width"
        showModal={values.showContactCreateModal}
      >
        <AddContact
          inModal
          type="purchaseOrder"
          onSubmit={(res) => {
            setStatus({
              ...status,
              vendorsList: [...status.vendorsList, res.data],
            });
            setValues({
              ...values,
              vendorID: res.data.id,
              showContactCreateModal: false,
            });
          }}
          close={closeModal}
          handleToast={handleToast}
          handlePrompt={handlePrompt}
        />
      </CustomModal>
    );
  };

  const newTaxModal = () => {
    return (
      <CustomModal
        title={t('Items.add_new_tax')}
        onClose={closeModal}
        renderActions={false}
        showPrompt={showPrompt}
        className="smallWidthClass"
        showModal={values.showTaxModal}
        classNames="UIUX-addtax-popup invoice-popup-set"
      >
        <TaxForm
          inModal
          type="add"
          onSubmitModal={(newitem) => {
            setStatus({
              ...status,
              taxList: [newitem, ...status.taxList],
            });
            setValues({
              ...values,
              taxID: newitem.id,
              showTaxModal: false,
            });
          }}
          closeModal={closeModal}
          enableFixedTax={enableTaxPerUnitMeasurement}
          handleToast={handleToast}
          handlePrompt={handlePrompt}
        />
      </CustomModal>
    );
  };
  const newOptionModal = () => {
    return (
      <CustomModal
        size="large"
        onClose={closeModal}
        title={t('Items.add_new_option')}
        renderActions={false}
        className="add_new_deleivery"
        modaltitle="delivery_modal_title"
        showModal={values.showOptionsModal}
      >
        <ItemAttributeOptionForm
          inModal
          type="add"
          onSubmitModal={(opt) => {
            let totalOptions =
              values.attributes[globalIndex].item_attribute_option.length;
            let newItem = {
              id: totalOptions + 1,
              name: opt,
              type: 'new_option',
            };
            values.attributes[globalIndex].item_attribute_option.push(newItem);
            values.attributes[globalIndex].attributeOptionValue = newItem.id;
            values.attributes[globalIndex].attributeOptionName = newItem.name;
            setFieldValue(
              `values.attributes[${globalIndex}].attributeOptionValue`,
              newItem.id
            );
            setFieldValue(
              `values.attributes[${globalIndex}].attributeOptionName`,
              newItem.name
            );
            setValues({
              ...values,
              showOptionsModal: false,
            });
          }}
          closeModal={closeModal}
          handleToast={handleToast}
        />
      </CustomModal>
    );
  };
  const hanldeImageUpload = (updatedFiles, croppedImage) => {
    updatedFiles[updatedFiles.length - 1].preview = croppedImage;
    updatedFiles.forEach((el) => {
      base64Images.push(el.preview);
      setFieldValue('base84Image', base64Images);
    });
    setFieldValue('uploadImages', updatedFiles);
    setFieldValue('showImageCropModal', false);
  };
  const ImageCropModal = () => {
    return (
      <CustomModal
        title={t('common.adjust_image')}
        onClose={closeModal}
        renderActions={false}
        className="smallWidthClass"
        showModal={values.showImageCropModal}
      >
        <ImageCropper
          inModal
          type="add"
          closeModal={closeModal}
          handleToast={handleToast}
          updatedFiles={values.imageUpload}
          onSubmitModal={(updatedFiles, croppedImage) => {
            hanldeImageUpload(updatedFiles, croppedImage);
          }}
        />
      </CustomModal>
    );
  };
  const renderModals = () => {
    return (
      <Fragment>
        {newTaxModal()}
        {ImageCropModal()}
        {newOptionModal()}
        {contactCreateModal()}
        {skipButton ? oldAccountModal() : newAccountModal()}
      </Fragment>
    );
  };
  const renderWarehouseTable = () => {
    return (
      <FieldArray
        name="warehouses"
        render={() => {
          return (
            <table
              className="form-focus list-table form-table border add_new_item add-item-variant"
              style={{ width: '100%' }}
            >
              <thead>
                <tr>
                  <th>{t('Items.warehouse_name')}</th>
                  <th>{t('Items.address')}</th>
                  <th className="right-align">{t('Items.opening_stock')}</th>
                </tr>
              </thead>
              <tbody>
                {values?.warehouses?.map((warehouse, index) => {
                  return (
                    <tr key={index}>
                      {warehouse.id ? (
                        <td className="warehouse-select-items-form">
                          {warehouse.name}
                        </td>
                      ) : (
                        <td className="warehouse-select-items-form">
                          <Field
                            type="dropdown"
                            autoFocus={true}
                            placeholder={t('Items.select_warehouse')}
                            value={warehouse.id}
                            options={status.warehousesList}
                            dropdownValue="id"
                            dropdownLabel="name"
                            clearable={false}
                            required={trackInventory}
                            handleChange={(option) =>
                              handleSelectedWarehouses(option, index)
                            }
                            error={getError(
                              errors,
                              touched,
                              `warehouses[${index}].name`
                            )}
                            onBlur={() =>
                              setFieldTouched(`warehouses[${index}].name`, true)
                            }
                          />
                        </td>
                      )}
                      <td className="wh-location">
                        <div>
                          {warehouse.address && warehouse.address !== '' && (
                            <div>{warehouse.address}</div>
                          )}
                          {warehouse.city && warehouse.city !== '' && (
                            <span>{warehouse.city}, </span>
                          )}
                          {warehouse.state && warehouse.state !== '' && (
                            <span>{warehouse.state}, </span>
                          )}
                          {warehouse.country && warehouse.country !== null && (
                            <span>{warehouse.country.country_name}</span>
                          )}
                          {warehouse.zipCode && warehouse.zipCode !== '' && (
                            <span> - {warehouse.zipCode}</span>
                          )}
                        </div>
                      </td>

                      <td className="right-align no-padding with-close--btn">
                        <Field
                          className="right-align"
                          type="number"
                          placeholder="0"
                          disabled={values.transactionInfo === true}
                          value={
                            warehouse?.openingStock >= 1
                              ? parseInt(warehouse?.openingStock)
                              : null
                          }
                          // decimalScale={6}
                          id={`warehouses[${index}].openingStock`}
                          thousandSeparator=","
                          onValueChange={(value) => {
                            let val = value?.floatValue;
                            if (val >= 0) {
                              let valString = val?.toString();

                              // Price_Quantity_Limit
                              // price and quantity limit from 5 digits to 10 digits
                              if (valString?.length > 10) {
                                valString = valString?.slice(0, 10);
                              }
                              val = parseInt(valString);
                            }
                            setFieldValue(
                              `warehouses[${index}].openingStock`,
                              val ? val : null
                            );
                          }}
                          onBlur={handleBlur}
                          error={getError(
                            errors,
                            touched,
                            `warehouses[${index}].openingStock`
                          )}
                        />
                        <div className="remove_row_button">
                          <button
                            className="close-btn button"
                            type="button"
                            disabled={
                              values.warehouses.length === 1 ||
                              values.warehouses[0].id === null
                            }
                            onClick={() => handleRemoveItem(index)}
                          >
                            <DeleteIcon />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          );
        }}
      />
    );
  };
  const inputProps = {
    value: values.unit || '',
    onChange: (event, { newValue }) => {
      if (event.target.id !== 'remove') {
        setFieldValue('unit', newValue);
      }
    },
    onBlur: () => setFieldTouched('unit'),
  };

  const handleSellingPriceChange = (sellPriceValue) => {
    let sellPrice = sellPriceValue.floatValue;
    if (sellPrice >= 0) {
      let sellPriceString = sellPrice.toString();

      // Price_Quantity_Limit

      // price and quantity limit from 5 digits to 10 digits
      if (sellPriceString.length > 10) {
        sellPriceString = sellPriceString.slice(0, 10);
      }
      sellPrice = parseFloat(sellPriceString);
    }
    setFieldValue('salesUnitPrice', sellPrice);
  };

  const handlePurchasePriceChange = (purchPriceValue) => {
    let purchPrice = purchPriceValue.floatValue;
    if (purchPrice >= 0) {
      let purchPriceString = purchPrice.toString();

      // Price_Quantity_Limit

      // price and quantity limit from 5 digits to 10 digits
      if (purchPriceString.length > 10) {
        purchPriceString = purchPriceString.slice(0, 10);
      }
      purchPrice = parseFloat(purchPriceString);
    }
    setFieldValue('purchaseUnitPrice', purchPrice);
  };
  let jango;
  let dummyArr = [];
  allWarehouses.forEach((allWare) => {
    jango = false;
    values.warehouses.forEach((ware) => {
      if (allWare.id === ware.id) {
        jango = true;
      }
    });
    if (jango === false) {
      dummyArr.push(allWare);
    }
  });
  status.warehousesList = dummyArr;

  return (

    <Fragment>
      {renderModals()}
      <Form
        className="item-form items-main-form"
        onSubmit={(event) =>
          formSubmit(
            event,
            values.warehouses,
            setFieldValue,
            handleSubmit,
            'id',
            'warehouses'
          )
        }
        type={inModal && 'modal'}
      >
        <FormSection title={t('Items.item_info')}>
          <div className="form-fields-container d-flex flex-wrap  position-relative all-items-main">
            <div
              className="form-image images-uploading"
              id="Click_Add_Item_Image"
            >
              <Field
                type="image"
                name={t('Items.add_images')}
                accept="image/*"
                onDrop={handleFiles}
                maxSize={5 * 1000 * 1000}
                // multiple  disabled multiple image upload
                camIconflag={true}
              />
              <ImagePreview
                images={[...values.images, ...values.uploadImages]}
                onDeleteImage={handleImageDelete}
              />
            </div>
            <Field
              className="flex-100"
              name={t('Items.item_name')}
              id="name"
              autoFocus={true}
              value={values.name}
              handleChange={handleChange}
              onBlur={handleBlur}
              required
              error={(touched.name || submitCount > 0) && errors.name}
            />
            <p className="form-field--side-btn maximum_char">
              {t('Items.max_characters')}
            </p>
            <div className="flex-100">
              <div className="d-flex">
                {item?.varients?.map((res, index) => (
                  <div key={index}>
                    &nbsp; &nbsp; <b> {Object.keys(res)}: </b> &nbsp; &nbsp;{' '}
                    {Object.values(res)} &nbsp; &nbsp;
                  </div>
                ))}
              </div>
            </div>
            {formType === 'itemGroup' && (
              <div className="d-flex flex-wrap w-100">
                {values?.attributes?.map((attr, index) => (
                  <Field
                    size="large"
                    type="dropdown"
                    key={index}
                    name={attr.name}
                    className="flex-25"
                    value={attr.attributeOptionValue}
                    options={attr.item_attribute_option}
                    clearable={false}
                    dropdownValue="id"
                    dropdownLabel="name"
                    handleChange={(option) => handleAttrChange(option, index)}
                    addButton={inModal ? false : true}
                    required
                    error={getError(
                      errors,
                      touched,
                      `attributes[${index}].attributeOptionValue`
                    )}
                    onBlur={() =>
                      setFieldTouched(
                        `attributes[${index}].attributeOptionValue`,
                        true
                      )
                    }
                  />
                ))}
              </div>
            )}

            <div className="flex-50">
              <div className="d-flex flex-wrap">
                <Field
                  className="flex-50"
                  size="large"
                  type="autosuggest"
                  name={t('Items.unit')}
                  id="unit"
                  value={values.unit}
                  placeholder="m, kg, litre"
                  suggestions={suggestions}
                  onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                  onSuggestionsClearRequested={onSuggestionsClearRequested}
                  removeSuggestion={false}
                  inputProps={inputProps}
                  required={values.type === 'goods'}
                  error={(touched.unit || submitCount > 0) && errors.unit}
                />

                <div className="position-relative flex-50 items_sku">
                  <Field
                    className="flex-100"
                    size="large"
                    name={t('common.sku')}
                    id="sku"
                    value={values.sku}
                    handleChange={handleChange}
                    onBlur={handleBlur}
                    required={values.type === 'goods'}
                    error={(touched.sku || submitCount > 0) && errors.sku}
                  />
                  {values.skuLoading ? (
                    <span className="display-flex-row-reverse">
                      <SmallLoader />
                    </span>
                  ) : (
                    <button
                      type="button"
                      onClick={generateSku}
                      className="button form-field--side-btn"
                      id="Click_generate_item_SKU"
                    >
                      {t('Items.generate_sku')}
                    </button>
                  )}
                </div>

                <Field
                  className="flex-50"
                  name={t('common.ean')}
                  id="ean"
                  value={values.ean}
                  handleChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.ean && errors.ean}
                />
                <Field
                  className="flex-50"
                  name={t('common.isbn')}
                  id="isbn"
                  value={values.isbn}
                  handleChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.isbn && errors.isbn}
                />
                <Field
                  className="flex-50"
                  name={t('Items.manufacturer')}
                  id="manufacturer"
                  value={values.manufacturer}
                  handleChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.manufacturer && errors.manufacturer}
                />
                <Field
                  className="flex-50"
                  name={t('Items.brand')}
                  id="brand"
                  value={values.brand}
                  handleChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.brand && errors.brand}
                />
                <Field
                  className="flex-50"
                  name={t('Items.dimension')}
                  id="dimensions"
                  type="text"
                  value={values.dimensions}
                  handleChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.dimensions && errors.dimensions}
                />
                <Field
                  className="flex-50"
                  name={t('Items.weight_kg')}
                  id="weight"
                  type="text"
                  value={values.weight}
                  handleChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.weight && errors.weight}
                />
              </div>
            </div>
            <div className="flex-50">
              <div className="d-flex flex-wrap">
                <Field
                  className="flex-50"
                  name={t('common.upc')}
                  id="upc"
                  value={values.upc}
                  handleChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.upc && errors.upc}
                />
                <Field
                  className="flex-50"
                  name={t('common.mpn')}
                  id="mpn"
                  value={values.mpn}
                  handleChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.mpn && errors.mpn}
                />
                <Field
                  className="flex-100 textarea-height"
                  type="textarea"
                  name={t('Items.description')}
                  id="description"
                  value={values.description}
                  handleChange={handleChange}
                  error={
                    (touched.description || submitCount > 0) &&
                    errors.description
                  }
                />
              </div>
            </div>
          </div>
        </FormSection>
        <hr className="item-hr" />
        {enableTaxPerUnitMeasurement && (
          <FormSection
            title={
              <TrackTaxMesaurementTitle
                isTaxInMilliGram={isTaxInMilliGram}
                handleTaxinMeasurement={handleisTaxinGram}
              />
            }
            className="margin-top-lg"
          >
            {isTaxInMilliGram && (
              <div className="form-fields-container d-flex flex-wrap  position-relative">
                <Field
                  className="flex-25"
                  size="large"
                  type="number"
                  name={`Pieces Per Pack`}
                  id="quantityPerPack"
                  value={parseInt(values.quantityPerPack) || ''}
                  required
                  // prefix={status.currency.symbol}
                  // decimalScale={2}
                  // disabled={values.transactionInfo === true}
                  // placeholder={`${status.currency.symbol} 0`}
                  handleChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.quantityPerPack && errors.quantityPerPack}
                />
                <Field
                  className="flex-25 text-transform-none"
                  size="large"
                  type="number"
                  name={`Volume/Weight per Piece (ml/g)`}
                  id="miliGramPerUnit"
                  value={values.miliGramPerUnit}
                  decimalScale={2}
                  required
                  handleChange={handleChange}
                  // onValueChange={(value) =>
                  //   setFieldValue('miliGramPerUnit', value)
                  // }
                  onBlur={handleBlur}
                  error={touched.miliGramPerUnit && errors.miliGramPerUnit}
                />
              </div>
            )}
          </FormSection>
        )}
        <hr className="item-hr" />
        <div className="form-fields-container d-flex flex-wrap  position-relative all-items-main margin-top-lg">
          <div className="flex-50">
            <FormSection
              title={t('Items.purchase_information')}
              className="w-100"
            >
              <div className="d-flex flex-wrap w-100">
                <div className="flex-50">
                  <Field
                    className="flex-100"
                    type="number"
                    name={t('Items.purchase_price')}
                    id="purchaseUnitPrice"
                    value={values.purchaseUnitPrice}
                    prefix={status.currency.symbol}
                    decimalScale={2}
                    placeholder={`${status.currency.symbol} 0`}
                    onValueChange={(value) => handlePurchasePriceChange(value)}
                    onBlur={handleBlur}
                    error={
                      touched.purchaseUnitPrice &&
                      (submitCount > 0 || errors.purchaseUnitPrice) &&
                      errors.purchaseUnitPrice
                    }
                  />

                  {accountDropDownField('expense')}

                  <Field
                    className="flex-100 position-relative"
                    type="dropdown"
                    name={t('Items.possible_vendor')}
                    id="vendorID"
                    value={values.vendorID}
                    options={status.vendorsList}
                    dropdownValue="id"
                    dropdownLabel="display_name"
                    handleChange={(option) => handleVendorChange(option)}
                    addButton={inModal ? false : true}
                  />
                </div>
                <div className="flex-50 textarea-height">
                  <Field
                    type="textarea"
                    name={t('Items.description')}
                    id="purchaseDescription"
                    value={values.purchaseDescription}
                    handleChange={handleChange}
                    error={
                      (touched.purchaseDescription || submitCount > 0) &&
                      errors.purchaseDescription
                    }
                  />
                </div>
              </div>
            </FormSection>
          </div>
          <div className="flex-50 sales-info-main">
            <FormSection title={t('Items.sales_information')} className="w-100">
              <div className="d-flex flex-wrap w-100">
                <div className="flex-50">
                  <Field
                    size="large"
                    type="number"
                    name={t('Items.selling_price')}
                    id="salesUnitPrice"
                    value={values.salesUnitPrice}
                    prefix={status.currency.symbol}
                    decimalScale={2}
                    placeholder={`${status.currency.symbol} 0`}
                    onValueChange={(value) => handleSellingPriceChange(value)}
                    onBlur={handleBlur}
                    error={
                      touched.salesUnitPrice &&
                      (submitCount > 0 || errors.salesUnitPrice) &&
                      errors.salesUnitPrice
                    }
                  />

                  {accountDropDownField('sales')}

                  <Field
                    size="large"
                    type="dropdown"
                    name={t('Items.item_tax')}
                    className="item_tax_dropdown"
                    id="taxID"
                    value={values.taxID}
                    options={status.taxList}
                    dropdownValue="id"
                    dropdownLabel="name"
                    handleChange={(option) => handleTaxChange(option)}
                    addButton={inModal ? false : true}
                  />
                </div>
                <div className="flex-50 textarea-height">
                  <Field
                    size="large"
                    type="textarea"
                    name={t('Items.description')}
                    id="salesDescription"
                    value={values.salesDescription}
                    handleChange={handleChange}
                    error={
                      (touched.salesDescription || submitCount > 0) &&
                      errors.salesDescription
                    }
                  />
                </div>
              </div>
            </FormSection>
          </div>
        </div>
        <FormSection
          title={
            <TrackInventoryTitle
              trackInventory={trackInventory}
              handleTrackInventory={handleTrackInventory}
            />
          }
          className="margin-top-lg"
        >
          {trackInventory && (
            <Fragment>
              <div className="form-field form-table--container no-margin itemform-warehouse">
                {!skipButton && accountDropDownField('inventory')}
                <label className="form-label">
                  {t('Items.choose_warehouse')}
                </label>
                {renderWarehouseTable()}
                {(type === 'add' || type === 'edit' || type === 'clone') && (
                  <AddItem
                    className="d-flex add-item-btn"
                    label={t('Items.add_warehouse')}
                    onClick={() =>
                      setFieldValue('warehouses', [
                        ...values.warehouses,
                        status.emptyWarehouse,
                      ])
                    }
                  />
                )}
              </div>
              <div className="form-fields-container d-flex flex-wrap  position-relative">
                <Field
                  className="flex-25"
                  size="large"
                  type="number"
                  name={t('Items.opening_stock_value')}
                  id="openingStockValue"
                  value={values.openingStockValue}
                  prefix={status.currency.symbol}
                  decimalScale={2}
                  disabled={values.transactionInfo === true}
                  placeholder={`${status.currency.symbol} 0`}
                  onValueChange={(value) =>
                    setFieldValue('openingStockValue', value.floatValue)
                  }
                  onBlur={handleBlur}
                  error={
                    (touched.openingStockValue || submitCount > 0) &&
                    errors.openingStockValue
                  }
                />

                <Field
                  className="flex-25"
                  size="large"
                  type="number"
                  name={t('Items.reorder_level')}
                  id="reorderLevel"
                  value={parseInt(values.reorderLevel)}
                  decimalScale={2}
                  onValueChange={(value) => {
                    setFieldValue(
                      'reorderLevel',
                      value.floatValue && parseInt(value.floatValue)
                    );
                  }}
                  onBlur={handleBlur}
                  error={touched.reorderLevel && errors.reorderLevel}
                />

                {/* <Field
                  className="flex-100 position-relative"
                  type="dropdown"
                  name="Raw Item"
                  id="raw_item_id"
                  value={values.raw_item_id}
                  options={status.rawItemsList}
                  dropdownValue="id"
                  dropdownLabel="name"
                  handleChange={(option) => handlerawItemChange(option)}
                  addButton={false}
                />
                <Field
                  className="flex-25"
                  size="large"
                  type="number"
                  name={t('Items.reorder_level')}
                  id="quantity"
                  value={parseInt(values.quantity)}
                  decimalScale={2}
                  onValueChange={(value) => {
                    setFieldValue(
                      'quantity',
                      value.floatValue && parseInt(value.floatValue)
                    );
                  }}
                  onBlur={handleBlur}
                  error={touched.quantity && errors.quantity}
                /> */}

              </div>
              {showRawItems() &&
                  <>
                    <label class="form-label">Choose Raw Item</label>
                    <FieldArray
                        name="rawItems"
                        render={(arrayHelpers) => (
                            <Fragment>
                              <table
                                  className="form-focus list-table form-table border add_new_item add-item-variant"
                                  style={{ width: '98%' }}
                              >
                                <thead>
                                <tr>
                                  <th style={{ width: '75%' }}>{t('Items.raw_item')}</th>
                                  <th className="right-align" style={{ width: '25%' }}>{t('ListTable.quantity')}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {values.rawItems.map((item, index) => {
                                  // console.log(item, "raw item")
                                  return (
                                      <tr key={index}>
                                        {/* Raw Item Dropdown */}
                                        <td className="vertical-middle " style={{ width: '75%' }}>
                                          <Field
                                              type="dropdown"
                                              placeholder={t('Items.select_item')}
                                              value={item.raw_item_id}
                                              options={status.rawItemsList.filter(option =>
                                                  !values.rawItems.some(
                                                      raw =>
                                                          raw.raw_item_id === option.id &&
                                                          raw.raw_item_id !== item.raw_item_id
                                                  )
                                              )}
                                              dropdownValue="id"
                                              dropdownLabel="name"
                                              clearable={false}
                                              handleChange={(option) =>
                                                  setFieldValue(`rawItems[${index}].raw_item_id`, option.value)
                                              }
                                              error={getError(
                                                  errors,
                                                  touched,
                                                  `rawItems[${index}].raw_item_id`
                                              )}
                                              onBlur={() =>
                                                  setFieldTouched(`rawItems[${index}].raw_item_id`, true)
                                              }
                                          />
                                        </td>

                                        {/* Quantity Field and Remove Button */}
                                        <td className="right-align no-padding with-close--btn" style={{ width: '25%' }}>
                                          <Field
                                              className="qty-field"
                                              type="number"
                                              placeholder="0"
                                              value={item?.quantity ? Number(item?.quantity) : null} // ← fix here

                                              id={`rawItems[${index}].quantity`}
                                              thousandSeparator=","
                                              onValueChange={(value) => {
                                                let val = value?.floatValue;
                                                if (val >= 0) {
                                                  let valString = val?.toString();

                                                  // Price_Quantity_Limit
                                                  // price and quantity limit from 5 digits to 10 digits
                                                  if (valString?.length > 10) {
                                                    valString = valString?.slice(0, 10);
                                                  }
                                                  val = parseInt(valString);
                                                }
                                                setFieldValue(
                                                    `rawItems[${index}].quantity`,
                                                    val ? val : null
                                                );
                                              }}
                                              onBlur={handleBlur}
                                              error={touched.rawItems &&
                                                  touched.rawItems[index]?.quantity &&
                                                  errors.rawItems &&
                                                  errors.rawItems[index]?.quantity} />
                                          <div className="remove_row_button">
                                            <button
                                                className="close-btn button"
                                                type="button"
                                                style={{ outline: 'none' }}
                                                disabled={values.rawItems.length === 1}
                                                onClick={() => arrayHelpers.remove(index)}
                                            >
                                              <DeleteIcon />
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                  );
                                })}
                                </tbody>
                              </table>
                              <AddItem
                                  className="d-flex add-item-btn"
                                  label={t('Items.add_new')}
                                  onClick={() =>
                                      arrayHelpers.push({ raw_item_id: null, quantity: 0 })
                                  }
                              />
                            </Fragment>
                        )}
                    />
                  </>
              }
            </Fragment>
          )}
        </FormSection>

        <FormAction
          disabled={isSubmitting}
          type="button"
          marginFromRight={0}
          onSubmit={handleSubmit}
          // setPrompt={props.setPrompt}
          onCancel={() => {
            let redirectItemsURL =
              formType === 'itemGroup' ? '/item-groups' : '/items';

            let dataFromLS = getObjFromLS('module');
            let redirectUrl = '';
            if (
              dataFromLS &&
              (dataFromLS.moduleName === 'items' ||
                dataFromLS.moduleName === 'item_groups')
            ) {
              redirectUrl = dataFromLS.queryParam;
            }
            if (inModal) {
              let response;
              let { checkout } = validateCreateItemForm(
                {
                  ...values,
                  trackInventory,
                  type,
                },
                staticVal
              );
              if (!checkout) {
                response = confirmationAlert();
              }
              if (response || checkout) {
                closeItem();
              }
            } else if (
              window.location.pathname.includes('add') ||
              window.location.pathname.includes('edit')
            ) {
              history.push(redirectItemsURL + redirectUrl);
            } else {
              setObjInLS('module', { ...dataFromLS, action: null });
              history.push('/r');
            }
          }}
        />

        <ErrorFocus />
      </Form>
    </Fragment>
  );
};

export default formEnhancer(ItemForm);
